module.exports = __webpack_public_path__ + "img/ice6.d8cd5c50.png";